document.addEventListener('DOMContentLoaded', () => {
  const { allEvents, eventIds, currentDate } = window;
  const eventButtonsContainer = document.getElementById('cart-event-buttons-container');
  const mainCheckoutButton = document.getElementById('checkout');
  const additionalCheckoutButtons = document.querySelector('.cart__dynamic-checkout-buttons');

  if (!allEvents || !eventIds || !currentDate || !eventButtonsContainer || !mainCheckoutButton) {
    return;
  }

  // Subscribe to cart update events to keep window.cartItems in sync
  subscribe('cart-update', (event) => {
    if (event.cartData && event.cartData.items) {
      window.cartItems = event.cartData.items;
      console.log('Cart items updated:', window.cartItems);
      // Re-validate on cart update if an event is selected
      if (selectedEventIndex !== null) {
        updateEventUI(selectedEventIndex);
      }
    }
  });

  const parseProductIdFromGid = (gid) => {
    if (typeof gid !== 'string') return null;
    const match = gid.match(/Product\/(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  };

  const eventsArray = Object.values(allEvents);
  const activeEvents = eventsArray.filter((event, index) => {
    const today = new Date(currentDate);
    const startDate = new Date(event.event_start_date);
    const endDate = new Date(event.event_end_date);
    return today >= startDate && today <= endDate;
  });

  let selectedEventIndex = null;

  const validateCartForEvent = (event) => {

    const eventExcludedIds = event.exclude_products?.map(parseProductIdFromGid).filter(id => id !== null) || [];

    // if (event.select_all_products) {
    //   return {
    //     isValid: true,
    //     invalidItems: [],
    //   };
    // }

    const eventProductIds = event.products?.map(parseProductIdFromGid).filter(id => id !== null) || [];
  
    const invalidItems = window.cartItems.filter(item => (eventProductIds.length && !eventProductIds.includes(item.product_id)) || eventExcludedIds.includes(item.product_id));

    return {
      isValid: invalidItems.length === 0,
      invalidItems,
    };
  };

  const hideStandardCheckout = (hide) => {
    if (mainCheckoutButton) mainCheckoutButton.style.display = hide ? 'none' : '';
    if (additionalCheckoutButtons) additionalCheckoutButtons.style.display = hide ? 'none' : '';
  };

  const updateEventUI = (eventIndex) => {
    // Clear previous dynamic content
    let dynamicContent = document.getElementById('event-dynamic-content');
    if (dynamicContent) dynamicContent.remove();

    dynamicContent = document.createElement('div');
    dynamicContent.id = 'event-dynamic-content';
    dynamicContent.style.marginBottom = '1rem';

    const event = eventsArray[eventIndex];
    const validation = validateCartForEvent(event);

    if (validation.invalidItems.length > 0) {
      const invalidList = validation.invalidItems.map(item => `<li>${item.title || item.product_title} (Qty: ${item.quantity})</li>`).join('');
      dynamicContent.innerHTML = `
        <p style="color: red;">Please remove the following items not available for ${event.event_name}:</p>
        <ul>${invalidList}</ul>
      `;
    }

    let isButtonDisabled = validation.invalidItems.length > 0;

    if (!window.customerId) {
      const guestInfoContainer = document.createElement('div');
      guestInfoContainer.classList.add('customer-form-fields');
      guestInfoContainer.innerHTML = `
        <label for="event-first-name">First Name:</label>
        <input type="text" id="event-first-name" class="field__input" placeholder="First Name">
        <label for="event-last-name">Last Name <span style="color: red;">*</span>:</label>
        <input type="text" id="event-last-name" class="field__input" placeholder="Last Name" required>
        <label for="event-email">Email <span style="color: red;">*</span>:</label>
        <input type="email" id="event-email" class="field__input" placeholder="your@email.com" required>
      `;
      dynamicContent.appendChild(guestInfoContainer);

      const firstNameInput = guestInfoContainer.querySelector('#event-first-name');
      const lastNameInput = guestInfoContainer.querySelector('#event-last-name');
      const emailInput = guestInfoContainer.querySelector('#event-email');

      const updateButtonState = () => {
        const proceedButton = document.getElementById('event-proceed-button');
        if (proceedButton) {
          const isEmailValid = emailInput.checkValidity() && emailInput.value.trim() !== '';
          const isLastNameValid = lastNameInput.value.trim() !== '';
          proceedButton.disabled = !isEmailValid || !isLastNameValid || validation.invalidItems.length > 0;
        }
      };

      firstNameInput.addEventListener('input', updateButtonState);
      lastNameInput.addEventListener('input', updateButtonState);
      emailInput.addEventListener('input', updateButtonState);

      isButtonDisabled = true; // Initially disable
      updateButtonState(); // Initial check
    }

    const proceedButton = document.createElement('button');
    proceedButton.id = 'event-proceed-button';
    proceedButton.type = 'button';
    proceedButton.classList.add('cart__checkout-button', 'button');
    proceedButton.textContent = 'Proceed to Checkout';
    proceedButton.disabled = isButtonDisabled;
    proceedButton.style.width = '100%';

    proceedButton.addEventListener('click', () => {
      proceedButton.disabled = true;
      proceedButton.textContent = 'Processing…';
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/apps/event-pickup';
      form.style.display = 'none';

      const eventNameInput = document.createElement('input');
      eventNameInput.type = 'hidden';
      eventNameInput.name = 'event_name';
      eventNameInput.value = event.event_name;
      form.appendChild(eventNameInput);

      const eventIdInput = document.createElement('input');
      eventIdInput.type = 'hidden';
      eventIdInput.name = 'event_id';
      eventIdInput.value = eventIds[eventIndex];
      form.appendChild(eventIdInput);

      const cartItemsInput = document.createElement('input');
      cartItemsInput.type = 'hidden';
      cartItemsInput.name = 'cart_items';
      cartItemsInput.value = JSON.stringify(window.cartItems.map(item => ({
        variant_id: item.variant_id,
        quantity: item.quantity
      })));
      form.appendChild(cartItemsInput);

      if (window.customerId) {
        const customerIdInput = document.createElement('input');
        customerIdInput.type = 'hidden';
        customerIdInput.name = 'customer_id';
        customerIdInput.value = window.customerId;
        form.appendChild(customerIdInput);
      } else {
        const emailInputValue = document.getElementById('event-email').value;
        const firstNameInputValue = document.getElementById('event-first-name').value;
        const lastNameInputValue = document.getElementById('event-last-name').value;
        const emailHiddenInput = document.createElement('input');
        emailHiddenInput.type = 'hidden';
        emailHiddenInput.name = 'email';
        emailHiddenInput.value = emailInputValue;
        form.appendChild(emailHiddenInput);

        const firstNameHiddenInput = document.createElement('input');
        firstNameHiddenInput.type = 'hidden';
        firstNameHiddenInput.name = 'first_name';
        firstNameHiddenInput.value = firstNameInputValue;
        form.appendChild(firstNameHiddenInput);

        const lastNameHiddenInput = document.createElement('input');
        lastNameHiddenInput.type = 'hidden';
        lastNameHiddenInput.name = 'last_name';
        lastNameHiddenInput.value = lastNameInputValue;
        form.appendChild(lastNameHiddenInput);
      }

      document.body.appendChild(form);
      form.submit();
    });

    dynamicContent.appendChild(proceedButton);

    mainCheckoutButton.parentElement.insertAdjacentElement('afterend', dynamicContent);
    hideStandardCheckout(true);
  };

  const showDeliveryUI = () => {
    const dynamicContent = document.getElementById('event-dynamic-content');
    if (dynamicContent) dynamicContent.remove();
    hideStandardCheckout(false);
  };

  // Create radio group
  const radioGroup = document.createElement('div');
  radioGroup.id = 'event-radio-group';
  radioGroup.style.marginBottom = '2rem';

  // Delivery option (default)
  const deliveryRadio = document.createElement('input');
  deliveryRadio.type = 'radio';
  deliveryRadio.id = 'delivery-option';
  deliveryRadio.name = 'pickup-option';
  deliveryRadio.value = 'delivery';
  deliveryRadio.checked = true;
  const deliveryLabel = document.createElement('label');
  deliveryLabel.htmlFor = 'delivery-option';
  deliveryLabel.textContent = 'Ship to my address';
  radioGroup.appendChild(deliveryRadio);
  radioGroup.appendChild(deliveryLabel);
  //radioGroup.appendChild(document.createElement('br'));

  // Store pickup option
  const storePickupRadio = document.createElement('input');
  storePickupRadio.type = 'radio';
  storePickupRadio.id = 'store-pickup-option';
  storePickupRadio.name = 'pickup-option';
  storePickupRadio.value = 'store-pickup';
  const storePickupLabel = document.createElement('label');
  storePickupLabel.htmlFor = 'store-pickup-option';
  storePickupLabel.textContent = 'In-store pick up at Blue Ridge Honey Company - Lakemont, GA';
  radioGroup.appendChild(storePickupRadio);
  radioGroup.appendChild(storePickupLabel);
  //radioGroup.appendChild(document.createElement('br'));

  activeEvents.forEach((event, activeIndex) => {
    // Find the original index in eventsArray
    const originalIndex = eventsArray.findIndex(ev => ev.event_name === event.event_name);
    const radio = document.createElement('input');
    radio.type = 'radio';
    radio.id = `event-${event.event_name.replace(/\s+/g, '-')}`;
    radio.name = 'pickup-option';
    radio.value = originalIndex.toString(); // Store the original index as value

    const label = document.createElement('label');
    label.htmlFor = radio.id;
    const pickupDate = new Date(event.pickup);
    const options = { month: 'short', day: 'numeric' };
    const formattedPickup = pickupDate.toLocaleDateString('en-US', options);

    label.textContent = `Pick up at ${event.event_name} - ${formattedPickup} - ${event.city} ${event.province_code}`;

    radioGroup.appendChild(radio);
    radioGroup.appendChild(label);
   // radioGroup.appendChild(document.createElement('br'));
  });

  eventButtonsContainer.appendChild(radioGroup);

  // Event listener for radio changes
  radioGroup.addEventListener('change', (e) => {
    if (e.target.value === 'delivery' || e.target.value === 'store-pickup') {
      selectedEventIndex = null;
      showDeliveryUI();
    } else {
      selectedEventIndex = parseInt(e.target.value, 10);
      if (selectedEventIndex !== null && selectedEventIndex >= 0 && selectedEventIndex < eventsArray.length) {
        updateEventUI(selectedEventIndex);
      }
    }
  });
}); 